module.exports = __webpack_public_path__ + "static/mihai-a6901438416615651acd5d5c2667097c.jpg";